// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__D8NPB","total":"Cart_total__r7Dz5","actions":"Cart_actions__mfaRZ","button--alt":"Cart_button--alt__Ev0n5","button":"Cart_button__cRUhq"};